import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
    return twMerge(clsx(inputs));
}

export function greetingKey() {
    const h = new Date().getHours();
    if (h < 11) return 'home.greeting.morning';
    if (h < 18) return 'home.greeting.afternoon';
    return 'home.greeting.evening';
}

export function todayString(locale = 'da') {
    return new Date().toLocaleDateString(
        { da: 'da-DK', en: 'en-GB', de: 'de-DE', sv: 'sv-SE', no: 'nb-NO' }[locale] || 'da-DK',
        { weekday: 'long', day: 'numeric', month: 'long' }
    );
}

const WMO = {
    0: { da: 'Klart', en: 'Clear', de: 'Klar', sv: 'Klart', no: 'Klart', icon: '☀️' },
    1: { da: 'Letskyet', en: 'Mostly clear', de: 'Leicht bewölkt', sv: 'Lättmolnigt', no: 'Lett skyet', icon: '🌤️' },
    2: { da: 'Skyet', en: 'Partly cloudy', de: 'Teilweise bewölkt', sv: 'Delvis molnigt', no: 'Delvis skyet', icon: '⛅' },
    3: { da: 'Overskyet', en: 'Overcast', de: 'Bewölkt', sv: 'Mulet', no: 'Overskyet', icon: '☁️' },
    45: { da: 'Tåge', en: 'Fog', de: 'Nebel', sv: 'Dimma', no: 'Tåke', icon: '🌫️' },
    48: { da: 'Rimtåge', en: 'Freezing fog', de: 'Reifnebel', sv: 'Frostdimma', no: 'Rimtåke', icon: '🌫️' },
    51: { da: 'Støvregn', en: 'Drizzle', de: 'Nieselregen', sv: 'Duggregn', no: 'Duskregn', icon: '🌦️' },
    53: { da: 'Støvregn', en: 'Drizzle', de: 'Nieselregen', sv: 'Duggregn', no: 'Duskregn', icon: '🌦️' },
    55: { da: 'Støvregn', en: 'Drizzle', de: 'Nieselregen', sv: 'Duggregn', no: 'Duskregn', icon: '🌦️' },
    56: { da: 'Isslag (støvregn)', en: 'Freezing drizzle', de: 'Gefrierender Niesel', sv: 'Underkylt duggregn', no: 'Underkjølt duskregn', icon: '🧊' },
    57: { da: 'Isslag (støvregn)', en: 'Freezing drizzle', de: 'Gefrierender Niesel', sv: 'Underkylt duggregn', no: 'Underkjølt duskregn', icon: '🧊' },
    61: { da: 'Let regn', en: 'Light rain', de: 'Leichter Regen', sv: 'Lätt regn', no: 'Lett regn', icon: '🌧️' },
    63: { da: 'Regn', en: 'Rain', de: 'Regen', sv: 'Regn', no: 'Regn', icon: '🌧️' },
    65: { da: 'Kraftig regn', en: 'Heavy rain', de: 'Starker Regen', sv: 'Kraftigt regn', no: 'Kraftig regn', icon: '🌧️' },
    66: { da: 'Isregn', en: 'Freezing rain', de: 'Eisregen', sv: 'Underkylt regn', no: 'Underkjølt regn', icon: '🧊' },
    67: { da: 'Kraftig isregn', en: 'Heavy freezing rain', de: 'Starker Eisregen', sv: 'Kraftigt underkylt regn', no: 'Kraftig underkjølt regn', icon: '🧊' },
    71: { da: 'Let sne', en: 'Light snow', de: 'Leichter Schnee', sv: 'Lätt snö', no: 'Lett snø', icon: '🌨️' },
    73: { da: 'Sne', en: 'Snow', de: 'Schnee', sv: 'Snö', no: 'Snø', icon: '🌨️' },
    75: { da: 'Kraftig sne', en: 'Heavy snow', de: 'Starker Schnee', sv: 'Kraftig snö', no: 'Kraftig snø', icon: '❄️' },
    77: { da: 'Kornsne', en: 'Snow grains', de: 'Griesel', sv: 'Kornsnö', no: 'Kornsnø', icon: '🌨️' },
    80: { da: 'Byger', en: 'Showers', de: 'Schauer', sv: 'Skurar', no: 'Byger', icon: '🌦️' },
    81: { da: 'Byger', en: 'Showers', de: 'Schauer', sv: 'Skurar', no: 'Byger', icon: '🌦️' },
    82: { da: 'Kraftige byger', en: 'Heavy showers', de: 'Starke Schauer', sv: 'Kraftiga skurar', no: 'Kraftige byger', icon: '⛈️' },
    85: { da: 'Snebyger', en: 'Snow showers', de: 'Schneeschauer', sv: 'Snöbyar', no: 'Snøbyger', icon: '🌨️' },
    86: { da: 'Kraftige snebyger', en: 'Heavy snow showers', de: 'Starke Schneeschauer', sv: 'Kraftiga snöbyar', no: 'Kraftige snøbyger', icon: '❄️' },
    95: { da: 'Tordenvejr', en: 'Thunderstorm', de: 'Gewitter', sv: 'Åska', no: 'Torden', icon: '⛈️' },
    96: { da: 'Torden med hagl', en: 'Thunderstorm with hail', de: 'Gewitter mit Hagel', sv: 'Åska med hagel', no: 'Torden med hagl', icon: '⛈️' },
    99: { da: 'Kraftig torden med hagl', en: 'Severe thunderstorm with hail', de: 'Schweres Gewitter mit Hagel', sv: 'Kraftig åska med hagel', no: 'Kraftig torden med hagl', icon: '⛈️' },
    // Not a WMO code: rain/drizzle falling at ≤1.5 °C (see weatherDetail)
    sleet: { da: 'Slud', en: 'Sleet', de: 'Schneeregen', sv: 'Snöblandat regn', no: 'Sludd', icon: '🌨️' },
};

export function wmoLabel(code, locale = 'da') {
    const entry = WMO[code] || WMO[3];
    return { label: entry[locale] || entry[(locale || '').split('-')[0]] || entry.en || entry.da, icon: entry.icon };
}
